import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root'
})
export class FilesService {

	constructor(public sanitizer: DomSanitizer) {
	}

	createRenderBlobUrl(blob, sanitize?) {
		let blobUrl: any = URL.createObjectURL(blob);
		if (sanitize) {
			blobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
		}
		return blobUrl;
	}

	downloadFile(fileName, blob) {
		if (navigator.msSaveBlob) {
			navigator.msSaveBlob(blob, fileName);
		} else {
			const link = document.createElement('a');
			const url = this.createRenderBlobUrl(blob);
			link.setAttribute('href', url);
			link.setAttribute('download', fileName);
			link.style.visibility = 'hidden';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}

	arrayBufferToBase64(buffer) {
		let binary = '';
		const bytes = new Uint8Array(buffer);
		const len = bytes.byteLength;
		for (let i = 0; i < len; i++) {
			binary += String.fromCharCode(bytes[i]);
		}
		return 'data:image/jpeg;base64,' + btoa(binary);
	}

	convertBlobToBase64(blob) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader;
			reader.onerror = reject;
			reader.onload = () => {
				resolve(this.sanitizer.bypassSecurityTrustResourceUrl(reader.result as string));
			};
			reader.readAsDataURL(blob);
		});
	}

	previewFile(blob) {
		const blobUrl = this.createRenderBlobUrl(blob);
		let win: any = window.open;
		if (!win) {
			win = window.document.open;
		}
		win(blobUrl, '_blank', 'width=largeImage.stylewidth,height=largeImage.style.height,resizable=1');
	}
}
